module.exports = __webpack_public_path__ + "assets/treeTable.90e38a2d.svg";